// src/App.js
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import MagicLogin from './pages/MagicLogin';
import ClientDashboard from './components/ClientDashboard';
import Expired from './pages/Expired';
import DashboardLayout from './components/layout/DashboardLayout';
import Projects from './pages/Projects';
import Messages from './pages/Messages';
import Files from './pages/Files';
import Settings from './pages/Settings';
import ClientList from './components/ClientList';
// import Dashboard from './components/Dashboard'; // ❌ optional and unused

import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import axios from './axiosConfig';

const AppContent = () => {
  const { authToken, magicToken, clientData, logout } = useAuth();
  const navigate = useNavigate();
  const [shouldLogout, setShouldLogout] = useState(false);

  useEffect(() => {
    console.log('✅ ClientDashboard:', ClientDashboard);
  }, []);

  const handleLogout = () => {
    logout();
    setShouldLogout(true);
  };

  useEffect(() => {
    if (shouldLogout) {
      navigate('/');
    }
  }, [shouldLogout, navigate]);

  useEffect(() => {
    axios
      .get('/projects/')
      .then((res) => console.log('✅ /projects/ response:', res.data))
      .catch((err) => console.error('❌ Error hitting /projects/:', err));
  }, []);

  const getDefaultRoute = () => {
  const hasMagic = magicToken && clientData?.default_project_id;
  const hasAuth = !!authToken;

  if (!hasMagic && !hasAuth) {
    return <Navigate to="/login" />;
  }

  if (hasAuth) return <Navigate to="/dashboard" />;
  if (hasMagic) return <Navigate to={`/client-dashboard/${clientData.default_project_id}`} />;
};

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/magic-login/:token" element={<MagicLogin />} />
        <Route path="/client-dashboard/:projectId" element={<ClientDashboard />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/" element={getDefaultRoute()} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout onLogout={handleLogout} />
            </PrivateRoute>
          }
        >
          <Route index element={<Projects />} />
          <Route path="messages" element={<Messages />} />
          <Route path="files" element={<Files />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route
          path="/clients"
          element={
            <PrivateRoute>
              <ClientList />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
};

const App = () => (
  <Router>
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </Router>
);

export default App;